import request from "@/utils/request";

export function inspectionApply(data) {
  return request({
    url: "/consumer/inspectionRecord/originator/apply",
    method: "post",
    data
  });
}

// /inspectionRecord/inspectedPerson/list
export function inspectionList(data) {
  console.log(data);
  return request({
    url: "/consumer/inspectionRecord/inspectedPerson/list",
    method: "post",
    data
  });
}

export function defaultConfig(data) {
  return request({
    url: "/consumer/inspectionRecord/inspectedPerson/defaultConfig",
    method: "post",
    data
  });
}

export function defaultConfigFind() {
  return request({
    url: "/consumer/inspectionRecord/inspectedPerson/defaultConfigFind",
    method: "get"
  });
}

export function inspectedPersonDeal(data) {
  return request({
    url: "/consumer/inspectionRecord/inspectedPerson/deal",
    method: "post",
    data
  });
}

export function inspectionTimeCheck() {
  return request({
    url: "/consumer/inspectionRecord/originator/timeCheck",
    method: "get"
  });
}

export function inspectionRecord(data) {
  return request({
    url: "/consumer/inspectionRecord/originator/list",
    method: "post",
    data
  });
}

export function visitReport(id) {
  return request({
    url: `/consumer/inspectionRecord/originator/visitReport?id=${id}`,
    method: "get"
  });
}



// WEBPACK FOOTER //
// ./src/api/inspection.js